import { Component, Input, OnInit } from "@angular/core";
import { ContractWebLocal } from "../../../models";
import { SharedService } from "../../../services";

@Component({
    selector: "app-contracts-card",
    templateUrl: "./contracts-card.component.html",
    styleUrls: ["./contracts-card.component.scss"],
})
export class ContractsCardComponent implements OnInit
{

    @Input() contract: ContractWebLocal;

    constructor(
        public sharedService: SharedService,
    ) { }

    ngOnInit(): void
    {

    }
}
